<template>
    <div class="csv-record-configuration">
        <a-steps v-model="current" type="navigation" size="small" :style="stepStyle">
            <a-step
                title="Upload CSV or Excel file"
                description="Upload CSV or Excel file"
                :status="current === 0 ? 'process' : 'wait'"
            />
            <a-step
                title="Data Manipulation"
                description="Map the fields to the columns"
                :status="current === 1 ? 'process' : 'wait'"
            />
        </a-steps>
        <div v-if="current === 0" class="fileSelection">
            <div class="file-box" @click="openSelectFile">
                <div class="">
                    <a-icon type="file-excel" style="font-size: 50px; color: #08c" />
                </div>
                <div class="file-details">
                    <span v-if="file">{{ file.name }}</span>
                    <span>{{ $t("wp.selectFile") }}</span>
                    <span>{{ $t("wp.csvOrExcelFile") }}</span>
                </div>
            </div>
        </div>
        <div v-if="current === 1" class="configuration">
            <div class="left">
                <section class="general">
                    <div class="field">
                        <label> First Row Contains Header ? </label>
                        <a-switch v-model="clone.firstRowContainsHeader" />
                    </div>

                    <div class="field" v-if="!excelMode">
                        <label> Seperator Character </label>
                        <a-select v-model="clone.seperator">
                            <a-select-option value=",">Comma (,)</a-select-option>
                            <a-select-option value=";">Semicolon (;)</a-select-option>
                        </a-select>
                    </div>
                </section>
                <a-divider />

                <section class="fields">
                    <section class="headers">
                        <label>AUTOMATION FIELD</label>
                        <label></label>
                        <label>EXCEL/CSV COLUMN</label>
                    </section>
                    <div class="field-wrapper" :key="item" v-for="(item, index) of clone.mapping">
                        <div class="field">
                            <a-input v-model="clone.mapping[index].field" />
                        </div>
                        <i class="material-icons">arrow_forward</i>
                        <div class="field">
                            <a-select
                                :value="clone.mapping[index].dataIndex"
                                :options="getSelectOptionsForColumns()"
                                @change="(value) => changeFieldValue(index, value)"
                            />
                        </div>
                        <a-button
                            class="btnDelete"
                            type="danger"
                            @click="() => clone.mapping.splice(index, 1)"
                            size="small"
                        >
                            <i class="material-icons">delete</i>
                        </a-button>
                    </div>
                    <a-button type="primary" @click="addField">+ {{ $t("calendar.addField") }}</a-button>
                </section>
            </div>
            <div class="right">
                <section class="result">
                    <label>Example Result Preview</label>

                    <ve-table
                        :columns="getTableDataSource().columns"
                        :table-data="getTableDataSource().rows"
                        :row-style-option="rowStyleOption"
                        :border-x="true"
                        :border-y="true"
                        id="audit-logs-table"
                        :fixed-header="true"
                    />
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import readXlsxFile from "read-excel-file";
import { mapState } from "vuex";

import { VeLocale, VePagination } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import StringUtils from "../../../../../../../utils/StringUtils";
import { generateRandomId } from "../../../../../../../utils/session";
import log2 from "../../../../../../../utils/log2";
import axios from "axios";
import { getExtensionFromFileName } from "../../../../../../../utils/utils";
import { uploadAsset } from "../../../../../../../api/assetUpload";
import mimeTypes from "../../../../../../../components/util/mimeTypes";
import ASSET_API from "../../../../../../../api/asset";

Vue.use(VePagination);
VeLocale.use(enUS);

const log = log2("CSVRecordsConfiguration");
export default {
    name: "CSVRecordsConfiguration",
    props: {
        value: {
            type: Object,
            default: () => ({
                assetId: null,
                mapping: {},
                firstRowContainsHeader: true,
                seperator: ",",
            }),
        },
    },
    data() {
        return {
            rowStyleOption: {
                stripe: true,
            },
            current: 0,
            stepStyle: {
                marginBottom: "20px",
            },
            file: null,
            headers: [],
            fileText: "",
            excelMode: false,
            importing: false,
            StringUtils,
            tableKey: 1,
            clone: _.cloneDeep(this.value) || {
                assetId: null,
                mapping: [],
                firstRowContainsHeader: true,
                seperator: ",",
            },
            asset: null,
            uploading: false,
            mappingInitialized: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    created() {
        this.current = this.clone.assetId ? 1 : 0;
    },

    methods: {
        addField() {
            this.clone.mapping.push({
                field: `field-${this.clone.mapping.length + 1}`,
                dataIndex: -1,
            });
        },
        save() {
            this.importing = true;
            setTimeout(() => {
                // const lines = this.clone.firstRowContainsHeader ? this.lines.slice(1) : this.lines;
                //
                // const contacts = lines.map((line) => {
                //     const values = this.excelMode ? line : line.split(this.clone.seperator);
                //     const contact = {
                //         phone: this.clearPhoneNumber(
                //             values[this.headers.findIndex((x) => x.uniqueId === this.mapping.phone)]
                //         ),
                //         name: values[this.headers.findIndex((x) => x.uniqueId === this.mapping.name)],
                //         email: values[this.headers.findIndex((x) => x.uniqueId === this.mapping.email)],
                //         contactProperties: this.contactProperties.reduce((acc, x) => {
                //             acc.push({
                //                 id: x._id,
                //                 value: values[this.headers.findIndex((y) => y.uniqueId === this.mapping[x._id])],
                //             });
                //             return acc;
                //         }, []),
                //     };
                //     return contact;
                // });
            }, 10);
        },
        changeFieldValue(index, dataIndex) {
            this.clone.mapping[index].dataIndex = dataIndex;
        },

        getSelectOptionsForColumns() {
            return this.headers.map((header) => {
                return {
                    label: header.name,
                    value: header.index,
                };
            });
        },
        processFile(asset) {
            log("processFile", { asset });
            const url = asset.v2Format && asset.cdnUrl
            ? asset.cdnUrl
            :`https://static.supsis.live/${asset.path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            log("processFile", { asset, url });
            axios.get(url).then((response) => {
                const isExcel = asset.ext !== "csv";
                this.excelMode = true;
                if (isExcel) {
                    readXlsxFile(response.data).then((rows) => {
                        this.lines = rows;
                        this.parseExcel(rows);
                        this.excelMode = true;
                        this.current = 1;
                    });
                } else {
                    const text = response.data;
                    this.fileText = text;
                    this.parseCSVText(text);
                    this.current = 1;
                    this.excelMode = false;
                }
            });
        },

        openSelectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute(
                "accept",
                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            );
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                const fileType = getExtensionFromFileName(file.name);
                if (file) {
                    this.file = URL.createObjectURL(file);
                    this.uploading = true;
                    let path = `${this.site._id}/automation/`;

                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        ext: mimeTypes[file.type] || fileType || "supsis",
                        size: file.size,
                        type: "automation"
                    });
                    log("file", { file, data });
                    if (file.size <= 10 * 1024 * 1024) {
                        axios({
                            method: data.method,
                            url: data.url,
                            data: file,
                            headers: {
                                "Content-Type": file.type,
                            },
                            onUploadProgress: (p) => {
                                const percent = Math.round((p.loaded * 100) / p.total);
                                this.uploadProgress = percent;
                            },
                        })
                            .then((res) => {
                                this.$message.success({
                                    content: `File uploaded successfully`,
                                    duration: 2,
                                    key: "uploading",
                                });
                                this.clone.assetId = data.asset._id;
                            })
                            .catch((err) => {
                                this.$message.error({
                                    content: "File upload failed",
                                    duration: 2,
                                    key: "uploading",
                                });
                            })
                            .finally(() => {
                                this.uploading = false;
                            });
                    } else {
                        log.warn("input is not suitable for send");
                        this.$message.error({
                            content: this.$t("message.assetOversize"),
                            duration: 2,
                            key: "uploading",
                        });
                        this.uploading = false;
                    }
                } else {
                    this.uploading = false;
                }
            };
            fileEl.click();
        },
        toVariableName(name) {
            return name
                .toString()
                .trim()
                .toLowerCase()
                .split(" ")
                .map((x) => x.trim().replace(/[^a-z0-9_]/g, ""))
                .filter((x) => x.length > 0)
                .join("-");
        },
        parseCSVText(text) {
            log("parseCSVText");
            let lines = text.split("\n");
            this.headers = [];
            const ids = [];
            this.headers = lines[0].split(this.clone.seperator).map((name, index) => {
                const _name = this.clone.firstRowContainsHeader ? name : `Column ${index + 1}`;

                let id = this.toVariableName(_name);
                const count = ids.filter((x) => x === id).length;
                if (count > 0) {
                    id = `${id}_${count + 1}`;
                }
                ids.push(id);
                const uniqueId = generateRandomId(4);

                return {
                    name: _name,
                    index,
                    id,
                    uniqueId,
                };
            });
            log("headers completed", this.headers);
            this.lines = lines;
            if (Object.keys(this.clone.mapping).length === 0 && !this.mappingInitialized) {
                this.clone.mapping = _.take(this.headers, 5).map((x) => {
                    return {
                        field: x.id,
                        dataIndex: x.index,
                    };
                });
                this.mappingInitialized = true;
                log("first mapping completed", {
                    mapping: this.clone.mapping,
                    headers: this.headers,
                });
            }
            this.tableKey = StringUtils.hashCodeObj(this.clone.mapping);
        },
        parseExcel(lines) {
            this.headers = [];
            this.headers = lines[0].map((name, index) => {
                const _name = this.clone.firstRowContainsHeader ? name : `Col-${index + 1}`;
                const id = this.toVariableName(_name);
                const uniqueId = generateRandomId(4);

                return {
                    name: _name,
                    index,
                    id,
                    uniqueId,
                };
            });
            this.lines = lines;
            // this.clone.mapping = _.cloneDeep(this.clone.mapping);
            this.tableKey = StringUtils.hashCodeObj(this.clone.mapping);
        },
        getTableDataSource() {
            const lines = this.clone.firstRowContainsHeader ? this.lines.slice(1) : this.lines;

            const colLabels = {};
            const columns = this.clone.mapping.map((item, index) => {
                return {
                    dataIndex: item.dataIndex,
                    priority: 1,
                    headerIndex: item.dataIndex,
                    field: item.field,
                    key: item.field,
                    title: item.field,
                    align: "left",
                };
            });

            const rows = _.take(lines, 5).map((line) => {
                const values = this.excelMode ? line : line.split(this.clone.seperator);
                const row = {};
                columns.forEach((col) => {
                    row[`${col.key}`] = values[col.dataIndex];
                });
                return row;
            });
            console.log("getTableDataSource", { columns, rows });
            return {
                columns,
                rows,
            };
        },
        fetchAsset() {
            if (this.clone.assetId) {
                ASSET_API.getAssetById(this.clone.assetId).then((asset) => {
                    this.asset = asset;
                    // if (this.excelMode) this.parseExcel(this.lines);
                    // else this.parseCSVText(this.fileText);
                    this.processFile(asset);
                });
            }
        },
    },
    mounted() {
        if (this.clone.assetId) this.fetchAsset();
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
                if (this.clone.assetId) this.fetchAsset();
            },
        },
    },
};
</script>

<style lang="scss">
.csv-record-configuration {
    .navs {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .fileSelection {
        display: flex;
        justify-content: center;
        align-items: center;

        .file-box {
            width: 100%;
            height: 200px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            width: 300px;
            background: azure;

            .file-details {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }

    .configuration {
        display: flex;
        gap: 10px;

        .left {
            width: 50%;
        }

        .right {
            width: 50%;
            overflow-y: auto;
            border-left: 1px solid #d9d9d9;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            section.footer {
                display: flex;
                justify-content: flex-end;
                gap: 10px;
            }
        }

        section.general {
            display: flex;
            gap: 20px;

            .field {
                display: flex;
                flex-direction: column;

                label {
                    font-size: 16px;
                    color: #232222;
                    font-weight: 600;
                }

                .ant-switch {
                    width: 10px;
                }
            }
        }

        section.headers {
            display: flex;
            gap: 5px;
            justify-content: space-between;
            width: 100%;

            label {
                width: 100%;
            }
        }

        section.fields {
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
            width: 100%;

            .field-wrapper {
                display: flex;
                gap: 5px;
                justify-content: space-between;
                width: 100%;

                .btnDelete {
                    visibility: hidden;
                }

                &:hover {
                    .btnDelete {
                        visibility: visible;
                    }
                }

                .field {
                    display: flex;
                    flex-direction: column;
                    min-width: 200px;
                    width: 40%;

                    label {
                        font-size: 16px;
                        color: #232222;
                        font-weight: 600;
                    }

                    .ant-switch {
                        width: 10px;
                    }
                }
            }

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }
        }

        section.result {
            display: flex;
            flex-direction: column;
            gap: 20px;

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }
        }
    }
}
</style>
